import {ReactElement} from "react";
import {Button, Card, Col, FormListFieldData, Input, Row, Select} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {getClients} from "../../services/ServiceClient";
import {useTranslate} from "@refinedev/core";
import {Custom} from "../../utils/refineUtils";
import IClient from "../../interfaces/IClient";

interface IProps {
    editable?: boolean
    client?: IClient
    index?: any
}

export default function ConfigItac(props: IProps): ReactElement | null {
    const translate = useTranslate()
    const {clients} = getClients()
    const workspacesType: string[] = clients?.find(client => client.id === "itac")?.config.workspaces
    return props?.editable ?
        <Custom.List name={[props?.index, "config", "workspaces"]} label="configClients.itac.workspaces"
                     editable={true}>
            {(workspaces: FormListFieldData[], remove: (index: number | number[]) => void) => <>
                <Row gutter={[0, 16]}>
                    {workspaces.map(({key, name: index}) => (
                        <Card key={key} size="small" style={{width: "100%"}}>
                            <Row>
                                <Col span={12}>
                                    <Custom.Item label={"configClients.itac.name"} name={[index, 'name']}>
                                        <Input/>
                                    </Custom.Item>
                                </Col>
                                <Col span={1}></Col>
                                <Col span={9}>
                                    <Custom.Item label={"configClients.itac.type"} name={[index, 'type']}>
                                        <Select options={workspacesType?.map(w => ({label: w, value: w}))}/>
                                    </Custom.Item>
                                </Col>
                                <Col span={1}></Col>
                                <Col span={1}>
                                    <Custom.Item label={null}>
                                        <Button onClick={() => remove(index)} icon={<DeleteOutlined/>}></Button>
                                    </Custom.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={12}>
                                    <Custom.Item label={'configClients.itac.zeMin'} name={[index, 'minZE']}>
                                        <Input type="number"/>
                                    </Custom.Item>
                                </Col>
                                <Col span={1}></Col>
                                <Col span={11}>
                                    <Custom.Item label={'configClients.itac.zeMax'} name={[index, 'maxZE']}>
                                        <Input type="number"/>
                                    </Custom.Item>
                                </Col>
                            </Row>
                        </Card>
                    ))}
                    {!workspaces.length &&
                        <Custom.IconInfo icon={null} label="configClients.itac.noWorkspaces"/>}
                </Row>
            </>}
        </Custom.List>
        :
        <Row gutter={[0, 16]}>
            {props.client?.config.workspaces.map((workspace: any) => (
                <Card key={workspace.name} size="small" style={{width: "100%"}}>
                    <Row>
                        <Col span={12}>
                            <Custom.IconInfo icon={null} label="configClients.itac.name"
                                             value={workspace.name}/>
                            <Custom.IconInfo icon={null} label="configClients.itac.type"
                                             value={workspace.type}/>
                        </Col>
                        <Col span={12}>
                            <Custom.IconInfo icon={null} label="configClients.itac.zeMin"
                                             value={workspace.minZE}/>
                            <Custom.IconInfo icon={null} label="configClients.itac.zeMax"
                                             value={workspace.maxZE}/>
                        </Col>
                    </Row>
                </Card>
            ))}
            {!props.client?.config.workspaces.length && <span>{translate('configClients.itac.noWorkspaces')}</span>}
        </Row>
}